import React from 'react';

import {
  Switch,
  Route,
  Redirect,
  useRouteMatch,
} from 'react-router-dom';

import PurchasedOrderList from './components/PurchasedOrderList';
import WatchedGroupPreOrderList from './components/WatchedGroupPreOrderList';

const PersonalPage = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <Redirect to={`${path}/purchased-orders`} />
      </Route>
      <Route exact path={`${path}/purchased-orders`}>
        <PurchasedOrderList />
      </Route>
      <Route exact path={`${path}/watched-group-pre-orders`}>
        <WatchedGroupPreOrderList />
      </Route>
    </Switch>
  );
};

export default PersonalPage;
